import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { logPageView } from '../firebase';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);

    // Log page view to Firebase Analytics
    logPageView(pathname, document.title);
  }, [pathname]);

  return null;
}

export default ScrollToTop;